module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-up.f254e43a.svg";